import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";
import { BmarkClientOrdersTableDefinitionFactory } from "../../model/BmarkClientOrdersTableDefinitionFactory";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RawDataBmarkClientOrdersAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: BmarkClientOrdersTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
